import { render, staticRenderFns } from "./TrainingProgressCard.vue?vue&type=template&id=56277443"
import script from "./TrainingProgressCard.vue?vue&type=script&lang=js"
export * from "./TrainingProgressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports